import React from "react";
import logo from "./../../images/grok pvt ltd logo.png";
import "./hackathon.css";
import { Link } from "react-router-dom";

const HackathonHome = () => {
    return (
        <div className="hackathonHeader">
            <header>
                <div>
                    <img src={logo} alt="" height={"50px"} width={"200px"} />
                </div>
                <div>
                    <h1>Hackathon Home Page</h1>
                </div>
                <div></div>
                <p></p>
            </header>

            <div class="android-more-section" style={{paddingTop: "40px", paddingBottom: "30px"}}>
                    <div class="android-section-title mdl-typography--display-1-color-contrast" style={{paddingBottom: "10px"}}>About Grok Learning:</div>
                    <div style={{ marginLeft: "12px", marginBottom:"0" }}>
                        <p style={{ marginBottom: "0" }}>
                            Grok Learning bridges the gap between the current education system and real-world requirements.
                        </p>
                        <p>
                            Using the Grovator Platform, Grok is teaching students to Apply Academic Concepts using the Latest Technologies to Solve Real-World Problems. Connecting our education system to the changing real world and keeping it relevant to the changing times.
                            <br />
                        </p>
                        <p>Grovator Platform :</p>
                        <p>
                            The Grovator® Applied Learning Platform is the next-gen Al-based Super Teacher. Grovator® nurtures the spirit of innovation in young minds and helps students assimilate fundamental academic concepts through an applied learning approach. It helps develop analytical skills and a problem-solving mindset. Grovator® enables building solutions for new industry problems using the latest technology such as IoT, 3D Printing, Data Science, Robotics, and AI. Grovator® comprises innovative knowledge modules, software tools, and hardware kits and follows a learning methodology with 30% theory and 70% practical.
                            <br />
                        </p>
                        <p>Grok Learning for Schools and Colleges:</p>
                        <p>
                            Grok Learning builds on the innate curiosity of young minds, provides them with technology to help explore the concepts learned in school, and tools and knowledge to build solutions to real-world problems.
                        </p>
                        <p>
                            Grovator® nurtures the spirit of innovation in young minds develops analytical skills and a problem-solving mindset and develops leadership skills to become job creators and innovators.
                        </p>
                    </div>
                </div>

            <div style={{borderTop: "1px solid black"}}></div>

            <div className="landing-links">
                <Link to="/school" target="_blank" style={{ color: "white" }}>
                    <div className="link">
                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 256 256" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M233.86,110.48,65.8,14.58A20,20,0,0,0,37.15,38.64L67.33,128,37.15,217.36A20,20,0,0,0,56,244a20.1,20.1,0,0,0,9.81-2.58l.09-.06,168-96.07a20,20,0,0,0,0-34.81ZM63.19,215.26,88.61,140H144a12,12,0,0,0,0-24H88.61L63.18,40.72l152.76,87.17Z"></path></svg>
                        <p>
                            School
                        </p>
                    </div>
                </Link>
                <Link to="/college" target="_blank" style={{ color: "white" }}>
                    <div className="link">
                    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 256" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M233.86,110.48,65.8,14.58A20,20,0,0,0,37.15,38.64L67.33,128,37.15,217.36A20,20,0,0,0,56,244a20.1,20.1,0,0,0,9.81-2.58l.09-.06,168-96.07a20,20,0,0,0,0-34.81ZM63.19,215.26,88.61,140H144a12,12,0,0,0,0-24H88.61L63.18,40.72l152.76,87.17Z"></path></svg>
                        <p>
                            College
                        </p>
                    </div>
                </Link>
            </div>
        </div>
    )
}

export default HackathonHome;
